"use strict";

export default class {
  constructor() {
    this.baseUrl =
      "https://meu.epanel.com.br/external-especial/email/submit/layout/3";
    this.loading = false; // quando está buscando objetos

    // Axios Jsonp Pro
    let axios = require("axios-jsonp-pro");
    this.axios = axios.create({
      baseURL: this.baseUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  submit(data, callback = false) {
    console.log("PostService.submit()");
    let self = this;
    self.loading = true;

    this.axios
      .post(this.baseUrl, data)
      .then(function(response) {
        self.loading = false;
        console.log(response);
        typeof callback === "function" ? callback(response.data) : null;
      })
      .catch(function(error) {
        self.loading = false;
        console.log(error);
      });
  }
}
